export const DOWNLOAD_IMAGES_JOB_KEY = 'download_images_job';
export const RESUME_DOWNLOAD_JOB_KEY = 'resume_download_job';
export const DOWNLOAD_FETCH_PROGRESS_KEY = 'download_fetch_progress';
export const DOWNLOAD_IMAGES_PROGRESS_KEY = 'download_images_progress';
export const ADMIN_COMPANY_METRICS_TOAST_KEY = 'admin_company_metrics_job';
export const ADMIN_BRAND_METRICS_TOAST_KEY = 'admin_brand_metrics_job';
export const ADMIN_PROJECT_METRICS_TOAST_KEY = 'admin_project_metrics_job';
export const ADMIN_PROJECT_FOLDER_METRICS_TOAST_KEY = 'admin_project_folder_metrics_job';
export const JOB_TTL_MS = 10 * 60 * 1000;
